import * as actionTypes from './actiontypes';
import * as API from './api';

export const updateUsageState = (payload, path) => {
  return {
    type: actionTypes.UPDATE_USAGE_STATE,
    payload,
    path
  };
}

export const getChatSessionTimeSeries = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.CHAT_SESSION_LOADING,
    });
    API.getChatSessionTimeSeries(payload, (error, response) => {
      if (!error && response) {
        dispatch({
          type: actionTypes.CHAT_SESSION_RECEIVED,
          payload: response,
        });
        if (callback) callback(response.chatSessionsTimeSeries);
      } else {
        dispatch({
          type: actionTypes.CHAT_SESSION_LOAD_ERROR,
        });
      }
    });
  };
}

export const getUserEngagementStats = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.USER_ENGAGEMENT_STATS_LOADING,
    });
    API.getUserEngagementStats(payload, (error, response) => {
      if (!error) {
        dispatch({
          type: actionTypes.USER_ENGAGEMENT_STATS_RECEIVED,
          payload: response,
        });
      } else {
        dispatch({
          type: actionTypes.USER_ENGAGEMENT_STATS_LOAD_ERROR,
        });
      }
    });
  };
}

export const getUserRetention = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.USER_RETENTION_LOADING,
    });
    API.getUserRetention(payload, (error, response) => {
      if (!error) {
        dispatch({
          type: actionTypes.USER_RETENTION_RECEIVED,
          payload: response,
        });
        if (callback) callback();
      } else {
        dispatch({
          type: actionTypes.USER_RETENTION_LOAD_ERROR,
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/data/redux/usage_details/actions.js